export const HOME_ROUTE = "/";
export const REGISTER_ROUTE = "/register";
export const LOBBY_ROUTE = "/lobby";
export const RECOVERY_ROUTE = "passwordrecovery";
export const CREATE_RESIDENCE = "/newresidence";
export const RESIDENCE = "/residence";
export const VOTE_LOBBY = "/votelobby";
export const VOTE = "/vote";
